window.$ = window.jQuery = require('jquery')

import Vue from 'vue'
import router from './router/index'
import App from './App.vue'
import store from './store/index'
import './registerServiceWorker'
import http from './services/http'
import httpNumerama from './services/http-numerama'

import VeeValidate, { Validator } from 'vee-validate';

import messages from 'vee-validate/dist/locale/pt_BR';

Validator.localize(messages);

Vue.use(VeeValidate, {
    locale: 'pt_BR'
});

require('./bootstrap');

Vue.http = Vue.prototype.$http = http;
Vue.httpNumerama = Vue.prototype.$httpNumerama = httpNumerama;

Vue.config.productionTip = false;

import filters from './filters';

Vue.use(filters);


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
